import {defineStore} from 'pinia'
import { ref } from 'vue'

export const useFavStore = defineStore("Fav",()=>{
    const count = ref(0)
    function setCount(newVal){
        count.value = newVal
    }
    return {count,setCount}
})